angular.module('CarsSaraBo').controller('InsurancesPriceController', ['$scope', '$routeParams','$q',
	'InsurancePriceService','$http','$location', 'NotificationService',	'SessionService','$cookies',
	'$translate','LoadingWheelService',
	function($scope, $routeParams,$q,insurancePriceService,$http,$location, notificationService,session, $cookies,$translate,loadingWheelService) {
		let companyOid;
		$scope.insurancesCodes = ['LI','CDW','SCDW'];
		$scope.itemInclusions = [];
		let insuranceOidSelected;
		let insuranceCodeSelected;
		let TOOLTIP_READ = "insurances_tooltip_read";
		const INCLUSION_MANDATORY = 2;
		$scope.TOOLTIP_UNDERSTOOD = 'UNDERSTOOD';
		$scope.TOOLTIP_CLOSE ="CLOSE";
		$scope.showInclusionsModal = false;
		$scope.showInclusionsTooltip = false;
		$scope.withoutCategoriesAndInsurances = false;
		$scope.loadingSuccess = false;

		$scope.inclusionsDetail = {
			"LI":{count:0,codes:[],configurable:false},
			"CDW":{count:0,codes:[],configurable:true},
			"SCDW":{count:0,codes:[],configurable:true}
		}

		$scope.initialize = function() {
			loadingWheelService.show();
			companyOid = $routeParams.oid;
			loadData();
			$scope.editableInsurancePrice = $scope.loggedUserAllowed('PERM_UPSELLING_CREATE');
		}

		function loadData(){
			$http.get("../rest/data/category/" + companyOid).success(function(response) {
				$scope.categories = response;
				loadCompany($scope.categories);

				$http.get("../rest/data/insurances/" + companyOid).success(function(response){
					$scope.insurances = response;
					$scope.insurancesCodes.forEach(code =>{
						updateInclusionsDetail(code);
					});
					loadingWheelService.hide();
					$scope.loadingSuccess = true;
					showTooltip();
				});
			});
		}

		function loadCompany(categoriesList){
			$scope.countryOid = session.session.countryOid;
			$scope.insurancePrices = [];

			insurancePriceService.get({companyOid: companyOid }, function(insurancePrices) {
				$scope.insurancePrices = insurancePrices;
				$scope.priceMatrix=$scope.generatePriceMatrix($scope.insurancePrices);
				$scope.withoutCategoriesAndInsurances = categoriesList.length === 0;
			});
		}

		function updateInclusionsDetail(code){
			$scope.inclusionsDetail[code].count = getInclusionsCount(code);
			$scope.inclusionsDetail[code].codes = getInclusionsCodes(code);
		}

		$scope.generatePriceMatrix= function(insurancePrices){
			var priceMatrix = {};
			for(i in insurancePrices){
				priceMatrix[[insurancePrices[i].insuranceOid,insurancePrices[i].categoryCode]]={"baseAmount":insurancePrices[i].baseAmount,"oid":insurancePrices[i].oid, "deductible":insurancePrices[i].deductible};
			}
			return priceMatrix;
		};

		$scope.edit = function(categoryOid){
			$location.path("/company/" +  companyOid + "/insurances/" + categoryOid )
		}

		$scope.removeInsurancePrice=function(oid){
			$scope.showModal("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", function() {
				$q.all([
					insurancePriceService.remove({companyOid: companyOid, oid: oid}).$promise
				]).then(function(response) {
					$scope.initialize();
					notificationService.notifyInfoByCode('common.confirmationMessage.SUCCESS_DELETE');
				});
			});
		}

		function getInclusionsCodes(code){
			let inclusions =$scope.insurances.filter(i=> i.code === code)[0].inclusions;
			return inclusions.filter(inc => inc.included).map(i=> i.code).slice(0,INCLUSION_MANDATORY);
		}

		$scope.createNewInsurance = function(){
			$location.path("/company/" +  $routeParams.oid + "/insurances/add" )
		}

		$scope.openNewFleet = function(){
			$location.path("/company/" +  $routeParams.oid + "/fleet/new" )
		}

		$scope.showBtnCreateInsurance = function(){
			return !$scope.withoutCategoriesAndInsurances && $scope.editableInsurancePrice;
		}

		//showing inclusions of insurance with code passed as parameter
		$scope.showInclusions = function (code){
			//first element of filtered array is the selected insurance
			let insuranceSelected = $scope.insurances.filter(i=> i.code === code)[0]
			$scope.insuranceCodeSelected = insuranceSelected.code;
			$scope.insuranceOidSelected = insuranceSelected.oid;
			$scope.itemInclusions = insuranceSelected.inclusions;

			if (!$scope.itemInclusions){
				notificationService.notifyErrorByCode('bookingList.ERROR.UNEXPECTED');
			}else{
				$scope.showInclusionsModal = true;
			}
		}

		$scope.hideInclusionsModal = function() {
			$scope.showInclusionsModal = false;
			$scope.itemInclusions = [];
			$scope.insuranceCodeSelected = "";
			$scope.insuranceOidSelected = "";
		}

		function getInclusionsCount(code){
			if($scope.insurances){
				let insurance =$scope.insurances.filter(i=> i.code == code);
				return insurance[0].inclusions.filter(i=> i.included == true).length - INCLUSION_MANDATORY;
			}
		}

		$scope.saveInclusions = function(){
			const codeSelected= $scope.insuranceCodeSelected;
			$http.put("../rest/data/insurances/" + companyOid + "/" + $scope.insuranceOidSelected + "/inclusions", $scope.itemInclusions)
				.success(function() {
					$scope.hideInclusionsModal();
					updateInclusionsDetail(codeSelected);
					notificationService.notifySuccessByCode('insurance.inclusions.SAVE_OK','',null);
				})
				.error(function() {
					$scope.hideInclusionsModal();
					notificationService.notifyErrorByCode('insurance.inclusions.ERROR_SAVE');
				})
				.catch(function() {
					$scope.hideInclusionsModal();
					notificationService.notifyErrorByCode('insurance.inclusions.ERROR_SAVE');
				});
		}

		$scope.isChecked = function(item){
			return item.included;
		}

		$scope.isMandatory = function(item){
			return item.type === "MANDATORY";
		}

		$scope.isRecommended = function(item){
			return item.type === "RECOMMENDED";
		}

		$scope.isIncludedInsurance = function(code){
			if($scope.insurances) {
				let insurance = $scope.insurances.filter(i => i.code === code);
				return insurance[0].included
			}
			return false;
		}

		$scope.selectAll = function(){
			$scope.itemInclusions.forEach(i=> i.included=true);
		}

		$scope.unselectAll = function(){
			$scope.itemInclusions.forEach(i=> {if (i.type!=="MANDATORY"){i.included=false}});
		}

		$scope.hideTooltip = function(from){
			$scope.showInclusionsTooltip = false;
			if(from===$scope.TOOLTIP_UNDERSTOOD){
				$cookies.put(TOOLTIP_READ, '3');
			}else{
				let infoTooltip = $cookies.get(TOOLTIP_READ);

				if (!infoTooltip) {
					$cookies.put(TOOLTIP_READ, '0');
				}else{
					$cookies.put(TOOLTIP_READ, (parseInt(infoTooltip, 10) + 1).toString());
				}
			}
		};

		function showTooltip(){
			let infoTooltip = $cookies.get(TOOLTIP_READ);

			if (!infoTooltip) {
				$cookies.put(TOOLTIP_READ, '0');
				infoTooltip = $cookies.get(TOOLTIP_READ);
			}

			if(parseInt(infoTooltip, 10) <= INCLUSION_MANDATORY){
				$scope.showInclusionsTooltip = true;
			}else{
				$scope.showInclusionsTooltip = false;
			}
		};

		$scope.initialize();
	}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/general_conditions_controllers/insurances_price_controller.js
// module id = 913
// module chunks = 3